/**
 * Route de l'écran « Upgrade plan » adaptée au type d'utilisateur.
 * - Investisseur immobilier    -> plans investisseurs (/pro-offers/investor)
 * - Chasseur immobilier        -> plans chasseur (/pro-offers/hunters)
 * - Agent indépendant          -> plans agent (/pro-offers/agents)
 * - Agence immobilière (pro)   -> offres pro (/pro-offers)
 * - Autres (diagnostiqueur…)   -> écran d'abonnement du type de compte (/upgrade-plan)
 * - Particulier                -> écran d'abonnement particulier (/upgrade-plan)
 *
 * Chaque type de pro doit mener à SA page d'offres / d'abonnement : auparavant
 * agent / chasseur / autres retombaient sur la page agence (/pro-offers).
 */
export const upgradePlanRoute = (role, accountType) => {
  const r = String(role || "").toLowerCase();
  if (r === "investor") return "/pro-offers/investor";
  if (r === "hunter") return "/pro-offers/hunters";
  if (r === "agent") return "/pro-offers/agents";
  if (r === "other") return "/upgrade-plan";
  if (accountType === "pro") return "/pro-offers";
  return "/upgrade-plan";
};